module.exports = __webpack_public_path__ + "static/media/who-13.82325089.jpg";